export default "__VITE_ASSET__BOzPlfLs__"